import React, { useState } from 'react';
import { Box, Button, Grid, Typography, useTheme } from '@mui/material';
import { get } from 'lodash';
import CustomerPopupModal from '../../components/form/CustomerPopupModal';

const ProfileCard = ({ title, subtitle, fields, document, rawData, onUpdate, readOnly }) => {
  const theme = useTheme();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const formatAddress = (prefix) => {
    const parts = [
      get(document, `${prefix}address1`),
      get(document, `${prefix}address2`),
      get(document, `${prefix}city`),
      get(document, `${prefix}state`),
      get(document, `${prefix}postal_code`),
    ].filter(Boolean);
    return parts.join(', ');
  };

  return (
    <>
      <Box
        sx={{
          padding: theme.spacing(2),
          border: `1px solid ${theme.palette.divider}`,
          borderRadius: '4px',
          marginBottom: theme.spacing(2),
          backgroundColor: theme.palette.background.paper,
          display: 'flex',
          height: '100%',
          flexDirection: 'column',
          justifyContent: 'space-between',
        }}
      >
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: theme.spacing(1),
          }}
        >
          <Typography
            variant="h6"
            sx={{
              fontWeight: theme.typography.fontWeightBold,
            }}
          >
            {title}
          </Typography>
          {rawData && !readOnly && (
            <Button
              id="edit-profile"
              variant="text"
              sx={{
                cursor: 'pointer',
                fontWeight: theme.typography.fontWeightBold,
              }}
              onClick={handleOpen}
            >
              Edit
            </Button>
          )}
        </Box>

        {subtitle && (
          <Typography
            variant="subtitle1"
            sx={{
              color: theme.palette.text.disabled,
              marginBottom: theme.spacing(1.5),
            }}
          >
            {subtitle}
          </Typography>
        )}

        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
            gap: theme.spacing(1.25),
          }}
        >
          {fields.map((field, index) => (
            <Grid
              container
              key={field.label}
              sx={{
                backgroundColor: index % 2 === 0 ? theme.palette.action.hover : 'inherit',
              }}
            >
              <Grid fontSize="0.90rem" size={{ xs: 4 }}>
                {field.label}:
              </Grid>
              <Grid
                size={{ xs: 5 }}
                fontSize="0.90rem"
                sx={{
                  maxWidth: 300,
                  wordWrap: 'break-word',
                  marginLeft: theme.spacing(1),
                }}
              >
                {field.label === 'Address'
                  ? formatAddress(field.key ? `${field.key}.` : '')
                  : String(get(document, field.key || 'defaultKey') || '-')}
              </Grid>
            </Grid>
          ))}
        </Box>
      </Box>
      {open && <CustomerPopupModal open={open} handleClose={handleClose} document={rawData} onSave={onUpdate} />}
    </>
  );
};

export default ProfileCard;
